import { createContext, useContext } from "react"

type PresenceContextValue = {
  isPresent: boolean
  /**
   * Registers a child component for exit animation tracking.
   * Returns a safeToRemove callback that MUST be called when the exit animation completes.
   * AnimatePresence waits for ALL registered children to call their safeToRemove before unmounting.
   */
  register: () => () => void
}

export const PresenceContext = createContext<PresenceContextValue | null>(null)

export function usePresenceContext() {
  const ctx = useContext(PresenceContext)
  if (!ctx) {
    throw new Error("usePresence must be used within AnimatePresence")
  }
  return ctx
}
